import { dashboardLoginUrl } from "@dashboard-config"
import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/admin")({
  beforeLoad: () => {
    throw redirect({ href: dashboardLoginUrl() })
  },
})
